import { cosmoAPI } from "@/core/Api/cosmoAxiosInstance";

export default {
  readRecord(id) {
    return cosmoAPI.get(`/record/${id}/`);
  },
  readAnswers(id) {
    return cosmoAPI.get(`/record/${id}/history/`);
  },
  readQuestions(id) {
    return cosmoAPI.get(`/record/${id}/question/answered/`);
  },
  // getpdf
  getRecordPdf(recordId) {
    return cosmoAPI.get(`/record/${recordId}/pdf/`);
  },
  // relaunch Logs
  getRecordsRelaunchLogs(recordId) {
    return cosmoAPI.get(`/record/${recordId}/log/`);
  },
  deleteFileFromRecord({ endpoint, payload }) {
    return cosmoAPI.delete(`${endpoint}`, { data: payload });
  },
  postRecord(campaignSlug) {
    return cosmoAPI.post(`/wallet/campaign/${campaignSlug}/record/`);
  },
};
